import { render, staticRenderFns } from "./title-3.vue?vue&type=template&id=5f5fa587&scoped=true"
import script from "./title-3.vue?vue&type=script&lang=js"
export * from "./title-3.vue?vue&type=script&lang=js"
import style0 from "./title-3.vue?vue&type=style&index=0&id=5f5fa587&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5fa587",
  null
  
)

export default component.exports